var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegularIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "regular-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 139.44 151.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.4,151.91C.23,150,0,148.76,0,147.53Q0,84.7,0,21.88C0,8.92,9,0,21.89,0h96c12.42,0,21.46,8.82,21.52,21.27q.13,34.34,0,68.67c-.05,12.42-9.09,21.15-21.58,21.16q-36.43,0-72.87,0a7.1,7.1,0,0,0-5.53,2.28Q21.75,131.14,4,148.76C3,149.71,1.94,150.56.4,151.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularIcon);
export default __webpack_public_path__ + "static/media/regular-icon.cbd6bf118f739ec2b2ad28fbc0634388.svg";
export { ForwardRef as ReactComponent };